import {IPaginationState, TWithPagination} from 'plugins/modules/pagination/types';
import {PAGINATION_TYPE, PAGE_SIZE} from 'plugins/modules/pagination/constants';

export const initialPaginationState: IPaginationState = {
    count: 1,
    page: 1,
    size: PAGE_SIZE,
    type: PAGINATION_TYPE.AUTO,
};

export const withPagination = <T>(originState: T): TWithPagination<T> => {
    return {
        ...originState,
        ...initialPaginationState,
    };
};
